/**
 * TASK-084 — how many references a redirect of the record would rewrite
 * (`GET /records/{id}/references-count`). CZNA-1577 lifted it out of the redirect dialog
 * when that became a page; the query key is unchanged.
 */
import { useQuery } from 'react-query';
import { useOkapiKy } from '@folio/stripes/core';
import { fetchReferencesCount } from '../api/recordService';
export var useReferencesCount = function (recordId, enabled) {
    if (enabled === void 0) { enabled = true; }
    var ky = useOkapiKy();
    return useQuery(['references-count', recordId], function () { return fetchReferencesCount(ky, recordId); }, { enabled: enabled && Boolean(recordId) });
};
export default useReferencesCount;
